
  import { Vue, Component, Prop } from "vue-property-decorator";
  import moment from "moment";

  import correctPaymentPeriodDate from '@/helpers/correctPaymentPeriodDate';
  import { SubscriptionStatus } from "@/entities/payment/SubscriptionStatus";

  @Component
  export default class SubscriptionPeriod extends Vue {
    @Prop({ type: Boolean, required: true }) readonly canceled!: boolean;
    @Prop({ type: Number, required: true }) readonly periodEnd!: number;

    get paymentPeriod(): string {
      const end = correctPaymentPeriodDate(this.periodEnd);
      return moment(end).format("MMMM DD, YYYY");
    }
  }
